import { render, staticRenderFns } from "./ConfigureLocation.vue?vue&type=template&id=19fa85a4&scoped=true&"
import script from "./ConfigureLocation.vue?vue&type=script&lang=js&"
export * from "./ConfigureLocation.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureLocation.vue?vue&type=style&index=0&id=19fa85a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa85a4",
  null
  
)

export default component.exports